import { Service } from '../types';

export const services: Service[] = [
  {
    title: 'Web Application Development',
    icon: 'icon-paintbrush',
    description: 'Build robust web applications from frontend to backend using technologies such as AWS, Angular, Node.js, Docker, and PostgreSQL, delivering secure, scalable, and user-friendly experiences for clients and end-users.',
  },
  {
    title: 'Technical Leadership and Coaching',
    icon: 'icon-genius',
    description: 'Offer technical leadership and guidance to development teams. Provide coaching and mentoring to developers, helping them improve their skills and achieve project goals. Assist in architectural design decisions and ensure the successful delivery of software projects.',
  },
  {
    title: 'DevOps Consulting and Implementation',
    icon: 'icon-briefcase',
    description: 'Streamline software development and deployment processes using DevOps tools like AWS, React.js, Docker, and Jenkins to optimize productivity, automate workflows, and enhance collaboration across teams.',
  },
  {
    title: 'Agile Software Development',
    icon: 'icon-bargraph',
    description: 'Leverage agile methodologies and collaborative tools like Jira and Confluence to deliver high-quality software solutions using Java, JavaScript, Node.js, React, and Angular, while embracing iterative development and continuous improvement.',
  },
  {
    title: 'Cloud Infrastructure Setup and Management',
    icon: 'icon-chat',
    description: 'Utilize knowledge of cloud platforms like DigitalOcean, Google Cloud, and Amazon Web Services (AWS) to help businesses set up, configure, and manage their cloud infrastructure. Offer services such as provisioning virtual machines, setting up networking, configuring load balancers, and optimizing cloud resources.',
  },
  {
    title: 'Systems Integration and API Development',
    icon: 'icon-search',
    description: 'Integrate applications seamlessly with third-party platforms like Zendesk, Jira, and SharePoint, developing RESTful APIs using Java, React, Node.js, and PostgreSQL for efficient data exchange and system interoperability.',
  },
];
